import React from 'react';

const PageNotFound = () => (
  <div className="d-flex mt-3 justify-content-center align-items-center text-center">
    <div>
      <h1>404</h1>
      <div>Page Not Found</div>
    </div>
  </div>
);

export default PageNotFound;
